export const userPermissions = [
  {
    key: 0,
    label: "UNDERWRITING",
  },
  {
    key: 1,
    label: "ADMINISTRATION",
  },
  {
    key: 2,
    label: "CLAIMS",
  },
  {
    key: 3,
    label: "REPORTING",
  },
  {
    key: 4,
    label: "AGENTS",
  },
  {
    key: 5,
    label: "IT",
  },
  {
    key: 6,
    label: "ALL USERS",
  },
  {
    key: 7,
    label: "ACCOUNTING",
  },
];

// export const permissionDetails = [
//     {
//         "permission": "RESCIND POLICY",
//         "postion": 125,
//         "UNDERWRITER": true,
//         "ADMINISTRATION": true,
//         "CLAIMS": true,
//         "REPORTING": false,
//         "AGENTS": false,
//         "IT": false,
//         "ALLUSERS": false,
//         "ACCOUNTING": false
//     },
//     {
//         "permission": "HIDE HISTORY",
//         "postion": 126,
//         "UNDERWRITER": true,
//         "ADMINISTRATION": true,
//         "CLAIMS": true,
//         "REPORTING": false,
//         "AGENTS": false,
//         "IT": false,
//         "ALLUSERS": false,
//         "ACCOUNTING": false
//     }
// ]

export const permissionDetails = {
  statusCode: 200,
  message: "Records fetched successfully.",
  response: [
    {
      id: 1,
      permission: "NEW BINDER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 2,
      permission: "EDIT BINDER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 3,
      permission: "DELETE BINDER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 4,
      permission: "POLICY CSR",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 5,
      permission: "NEW POLICY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 6,
      permission: "AMMEND POLICY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 7,
      permission: "ISSUE NOTICE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 8,
      permission: "CANCEL POLICY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 9,
      permission: "REINSTATE POLICY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 10,
      permission: "UPDATE LOSS PAYEE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 11,
      permission: "NON RENEWAL",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 12,
      permission: "FORM LETTER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 13,
      permission: "PUT ON HOLD",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 14,
      permission: "NEW QUOTE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 15,
      permission: "EDIT QUOTE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 16,
      permission: "ISSUE RENEWAL",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 17,
      permission: "SUSPENSE FORM",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 18,
      permission: "PRINT UND FORMS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 19,
      permission: "NEW 1ST REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 20,
      permission: "EDIT 1ST REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 21,
      permission: "VOID 1ST REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 22,
      permission: "NEW CLAIM",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 23,
      permission: "CLAIMS CSR",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 24,
      permission: "EDIT CLAIM",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 25,
      permission: "NEW SUBRO",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 26,
      permission: "EDIT SUBRO",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 27,
      permission: "NEW SALVAGE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 28,
      permission: "EDIT SALVAGE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 29,
      permission: "VOID SALVAGE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 30,
      permission: "PROCESS PIP INVOICE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 31,
      permission: "PRINT PIP LOG",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 32,
      permission: "SUSPENSE NEW FORM",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 33,
      permission: "PRINT CLAIMS FORMS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 34,
      permission: "AD HOC FORM",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 35,
      permission: "ADD PROVIDERS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 36,
      permission: "CLAIM PAYMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 37,
      permission: "MONEY BATCH",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 38,
      permission: "RETURN BATCH",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 39,
      permission: "ADJUSTMENT BATCH",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 40,
      permission: "DAILY BATCH REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 41,
      permission: "WEEKLY BATCH REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 42,
      permission: "MONTHLY BATCH REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 43,
      permission: "MAINTAIN CLAIMS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 44,
      permission: "SEARCH IMAGING",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ALL USERS",
    },
    {
      id: 45,
      permission: "GENERAL COMMISSIONS PAYABLES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 46,
      permission: "TRIAL PAYABLES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 47,
      permission: "TRIAL RECEIVABLES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 48,
      permission: "TRIAL ACCOUNT SUMMARY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 49,
      permission: "UPDATE CHECK STATUS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 50,
      permission: "MANAGE UNDERWRITING",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 51,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 52,
      permission: "AGED CHECK REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 53,
      permission: "CREATE BANK FILE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 54,
      permission: "NEW AGENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 55,
      permission: "EDIT AGENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 56,
      permission: "AGENT CSR",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 57,
      permission: "RUN STATEMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 58,
      permission: "VIEW STATEMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 59,
      permission: "REPRINT STATEMENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 60,
      permission: "AGENT LETTERS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 61,
      permission: "AGENT REPORTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 62,
      permission: "REVERT POLICY TO BINDERS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 63,
      permission: "REVERSE ENDORSEMENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 64,
      permission: "REVERSE NOTICE REINSTATEMENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 65,
      permission: "USER AND GROUP SECURITY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 66,
      permission: "MGA INCOME",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 67,
      permission: "ACCOUNT CURRENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 68,
      permission: "MONTHLY EARNED",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 69,
      permission: "DAILY LOSS REGISTER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 70,
      permission: "MONTHLY LOSS REGISTER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 71,
      permission: "OUTSTANDING RESERVES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 72,
      permission: "CLAIMS WITH ZERO RESERVES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 73,
      permission: "MONTHLY CHECK REGISTER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 74,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 75,
      permission: "ISO STATISTICS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 76,
      permission: "TRIANGLE REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 77,
      permission: "GENERATE LOSS RATIO",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 78,
      permission: "USER STATISTICS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 79,
      permission: "AGED BINDERS REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 80,
      permission: "MONEY SUSPENSE REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 81,
      permission: "PRINT MAILING LIST",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 82,
      permission: "RENEWAL REPORT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "REPORTING",
    },
    {
      id: 83,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 84,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 85,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 86,
      permission: "USER CALENDAR",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ALL USERS",
    },
    {
      id: 87,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 88,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 89,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 90,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 91,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 92,
      permission: "EDIT PROVIDERS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 93,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 94,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 95,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 96,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 97,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 98,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 99,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 100,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 101,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 102,
      permission: "PORTAL OPTIONS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 103,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 104,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 105,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 106,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 107,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 108,
      permission: "RUN NIGHTLY JOB",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 109,
      permission: "CHANGE SYSTEM SERVER",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 110,
      permission: "SWEEP AGENT ACCOUNTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 111,
      permission: "PROCESS EFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 112,
      permission: "POSITIVE PAY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 113,
      permission: "AUDIT IMAGING",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 114,
      permission: "AUDIT CLAIMANTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 115,
      permission: "USER DIARY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ALL USERS",
    },
    {
      id: 116,
      permission: "AUDIT BANK INFO",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 117,
      permission: "REVERSE EFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 118,
      permission: "REVERSE ACH",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 119,
      permission: "AUDIT ACH/EFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 120,
      permission: "BULK MAIL",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 121,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 122,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 123,
      permission: "APPROVE POLICY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 124,
      permission: "VIEW PORTAL LOGS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 125,
      permission: "MANAGE TIME CLOCKS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 126,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 127,
      permission: "MANAGE ACH/EFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 128,
      permission: "MANAGE PALMS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 129,
      permission: "REVERSE ENDORSEMENT CLEANUP",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 130,
      permission: "REPORT ISSUE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ALL USERS",
    },
    {
      id: 131,
      permission: "BATCH REPRINT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 132,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 133,
      permission: "AGENT ADDRESS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 134,
      permission: "PROCESS CHECKS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 135,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 136,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 137,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 138,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 139,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 140,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 141,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 142,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 143,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 144,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 145,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 146,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 147,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 148,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 149,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 150,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 151,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 152,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 153,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 154,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 155,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 156,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 157,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 158,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 159,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 160,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 161,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 162,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 163,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 164,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 165,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 166,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 167,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 168,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 169,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 170,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 171,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 172,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 173,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 174,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 175,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 176,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 177,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 178,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 179,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 180,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 181,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 182,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 183,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 184,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 185,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 186,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 187,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 188,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 189,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 190,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 191,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 192,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 193,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 194,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 195,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 196,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 197,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 198,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 199,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 200,
      permission: null,
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: null,
    },
    {
      id: 201,
      permission: "DELETE CLAIM NOTES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 202,
      permission: "QA OVERRIDE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 203,
      permission: "VIEW/EDIT BANK INFO",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 204,
      permission: "BYPASS PROVIDER INSPECTION",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 205,
      permission: "STOP PAYMENT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 206,
      permission: "REVERSE ACH/EFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 207,
      permission: "NSF",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 208,
      permission: "ENDORSEMENT RE-RATE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 209,
      permission: "DELETE POLICY NOTES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 210,
      permission: "REVERSE CYBERSOURCE EFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 211,
      permission: "2500 PIP CLAIMANTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 212,
      permission: "5000 PIP CLAIMANTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 213,
      permission: "MORE THAN 5000 PIP CLAIMANTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 214,
      permission: "PAYMENT ON INVESTIGATED CLAIMANT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 215,
      permission: "RECALC INSTALLMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 216,
      permission: "POLICY DEBUG",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 217,
      permission: "VIEW DECRYPT BANKINFO",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 218,
      permission: "DEBUG RATING",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 219,
      permission: "VOID CHECK",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 220,
      permission: "VOID UW PAYMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 221,
      permission: "MANAGE SUSPENSE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 222,
      permission: "MANUAL DRAFT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 223,
      permission: "APPROVE QUOTE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 224,
      permission: "REINSTATEMENT PAST NOTICE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 225,
      permission: "MANAGE POLICYNOTES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 226,
      permission: "NO NSF FEE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 227,
      permission: "POLICY WARNINGS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 228,
      permission: "UPLOAD NEW FEATURES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 229,
      permission: "MANAGER ONLY NOTE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ALL USERS",
    },
    {
      id: 230,
      permission: "DELETE AGENT NOTES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 231,
      permission: "REQUEST CHECK",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 232,
      permission: "TRANSFER MONEY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 233,
      permission: "CHANGE PAYMENT TYPE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 234,
      permission: "ALLOW LIMIT OVERRIDE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 235,
      permission: "MODIFY INSTALLMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 236,
      permission: "ALLOW UND HIDE IMAGING",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 237,
      permission: "HIDE HISTORY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 238,
      permission: "UNHIDE HISTORY",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 239,
      permission: "VALIDATE LYONS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 240,
      permission: "MANAGER REVIEWED",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 241,
      permission: "ADD ACH RECORDS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 242,
      permission: "AGENT MVR CHARGE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "AGENTS",
    },
    {
      id: 243,
      permission: "OVERRIDE RP PAYEE",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 244,
      permission: "SET AT FAULT",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 245,
      permission: "BYPASS GENERATE RENQUOTE VALIDATION",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ADMINISTRATION",
    },
    {
      id: 246,
      permission: "BYPASS GENERATE RENQUOTE STATUS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 247,
      permission: "BYPASS GENERATE RENQUOTE DATES",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 248,
      permission: "SEARCH ALL PAYMENTS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 249,
      permission: "VIEW AGED CLAIMS CHECKS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "ACCOUNTING",
    },
    {
      id: 250,
      permission: "BYPASS OOSE CHECKS",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "UNDERWRITING",
    },
    {
      id: 251,
      permission: "EDIT RESERVE AUTHORIZATION",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 252,
      permission: "CLOSE CLAIM",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "CLAIMS",
    },
    {
      id: 254,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 255,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 256,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 257,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 258,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 259,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 260,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
    {
      id: 261,
      permission: "",
      role: {
        test4: false,
        test2: false,
        test3: false,
        test1: false,
      },
      department: "",
    },
  ],
};
